import { ContactLabels } from '@cian/contact-card-component';
import { DocumentsZhk16 } from '@cian/ui-kit';
import * as React from 'react';

const AgencyLabelsComponent: React.FC = () => {
  return (
    <ContactLabels
      labels={[
        {
          icon: <DocumentsZhk16 color="primary_100" />,
          title: 'Документы проверены',
        },
      ]}
    />
  );
};

export const AgencyLabels = React.memo(AgencyLabelsComponent);
